const TempLogger = {
    extend: () => TempLogger,
    setContextValue: () => { },
    removeContextValue: () => { },
    trace: (...args) => {
        console.warn('[sdk-twilio] logger called before configureTwilioLogger()');
        console.trace(...args);
    },
    isTrace: () => true,
    debug: (...args) => {
        console.warn('[sdk-twilio] logger called before configureTwilioLogger()');
        console.debug(...args);
    },
    isDebug: () => true,
    info: (...args) => {
        console.warn('[sdk-twilio] logger called before configureTwilioLogger()');
        console.info(...args);
    },
    isInfo: () => true,
    warn: (...args) => {
        console.warn('[sdk-twilio] logger called before configureTwilioLogger()');
        console.warn(...args);
    },
    isWarn: () => true,
    error: (...args) => {
        console.warn('[sdk-twilio] logger called before configureTwilioLogger()');
        console.error(...args);
    },
    isError: () => true,
};
export let logger = TempLogger;
export function setLogger(nextLogger) {
    logger = nextLogger;
}
//# sourceMappingURL=logger.js.map